/* Graph of Life brand v1.0.0 · tokens.json */
// Central configuration. Publication URL stays null until a canonical
// live publication address is verified, so no dead CTA can ship.

export const contact = {
  email: 'jg@graphoflife.com',
  reviewSubject: 'Dependency Exposure Review',
};

export const reviewMailto = `mailto:${contact.email}?subject=${encodeURIComponent(contact.reviewSubject)}`;

export const scopePath = '/scope';

export const publication = {
  name: 'The Graph Beneath the Balance Sheet',
  description:
    'Essays connecting ecological dependencies, accountable reasoning and the decisions institutions need to examine.',
  // Set to the canonical publication home once verified. Null hides the subscribe action.
  url: null,
  unavailableLabel: 'Publication link being updated',
};

export const essays = [
  {
    id: 'ontological-gap',
    question: 'Why does a blue-carbon claim pass verification and still fail diligence?',
    title: 'The Ontological Gap in Blue Carbon Markets',
    summary:
      'A credit can satisfy a protocol and still leave the mechanism carrying the risk undocumented. What must the evidence chain contain before a claim becomes genuinely inspectable?',
    url: 'https://substack.com/home/post/p-198707051',
  },
  {
    id: 'dependency-before-disclosure',
    question: 'What disappears when a dependency is flattened into a score?',
    title: 'Nature Risk Is a Dependency Problem First',
    summary:
      'Disclosure categories describe exposure after the fact. Dependency structure shows how it travels. The gap between the two decides what a screening exercise can actually see.',
    url: null,
  },
  {
    id: 'letting-evidence-challenge',
    question: 'How should a decision system report where it is wrong?',
    title: 'Letting the Evidence Challenge the Model',
    summary:
      'A governed graph is defensible only when observed evidence can contradict it openly. Evidence tiers, committed traces and published failure cases, examined end to end.',
    url: null,
  },
];

export const primaryNav = [
  { label: 'Overview', to: '/' },
  { label: 'Work With Me', to: '/#engagement' },
  { label: 'Applications', to: '/#applications' },
  { label: 'Proof', to: '/systems' },
  { label: 'Method', to: '/methodology' },
  { label: 'Writing', to: '/#writing' },
];

export const secondaryNav = [
  { label: 'Worldview', to: '/thesis', desc: 'Thesis and philosophy' },
  { label: 'Blue Capital', to: '/blue-capital', desc: 'Natural-capital application' },
  { label: 'Knowledge Systems', to: '/knowledge', desc: 'Technical architecture' },
  { label: 'Foundation', to: '/about', desc: 'Background and scientific partners' },
];
